import { Entity } from "./Entity";
import { DumpsterSize, ServiceType } from "./Order";

export enum PickUpStatus {
  CREATED = "created",
  SCHEDULED = "scheduled",
  COMPLETE = "complete",
  CANCELED = "canceled",
}

export interface PickUp extends Entity {
  address: string;
  zip: string;
  service: ServiceType;
  dumpsterSize?: DumpsterSize;
  pickupDate: string;
  status: PickUpStatus;
  orderId: string;
  driverId?: string;
  name: string;
  instructions: string;
  materialDisposing: string;
  latitude: number;
  longitude: number;
  priority: number;
  city: string;
}

/** A canceled pickup isn't serviced, so it's excluded from schedules/optimization. */
export const isPickupCanceled = (p: Pick<PickUp, "status">): boolean =>
  p.status === PickUpStatus.CANCELED;
